import { type GetShopLikesQueryParams } from '../shop/aliases';

import {
  LIKED_PRODUCTS_ENDPOINT,
  UPDATE_PRODUCT_LIKE_ENDPOINT,
} from '@/constants/endpoints.ts';
import { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';

export function addProductLike(productId: number) {
  return typedHttp.put(
    replacePathParams(UPDATE_PRODUCT_LIKE_ENDPOINT, {
      productId: productId.toString(),
    }),
    null,
    { withAuth: true }
  );
}

export function deleteProductLike(productId: number) {
  return typedHttp.delete(
    replacePathParams(UPDATE_PRODUCT_LIKE_ENDPOINT, {
      productId: productId.toString(),
    }),
    { withAuth: true }
  );
}

export function fetchLikedProducts(
  params: GetShopLikesQueryParams,
  userId: number
) {
  return typedHttp.get(
    replacePathParams(LIKED_PRODUCTS_ENDPOINT, { userId: userId.toString() }),
    {
      params,
      withAuth: true,
      withDeviceId: true,
    }
  );
}
